import type { JSX } from 'react';
import { TextField } from '../../../_components/TextField.js';
import type { FeedbackPalette, WidgetStep } from '../types.js';

interface IdentityStepProps {
  palette: FeedbackPalette;
  step: WidgetStep;
  fullName: string;
  email: string;
  onFullNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
}

export function IdentityStep({
  palette,
  step,
  fullName,
  email,
  onFullNameChange,
  onEmailChange,
}: IdentityStepProps): JSX.Element {
  const askEmail = step.askEmail ?? true;
  const askName = step.askName ?? false;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {askName && (
        <TextField
          palette={palette}
          type="text"
          value={fullName}
          onChange={onFullNameChange}
          placeholder="Your name"
          ariaLabel="Your name"
        />
      )}
      {askEmail && (
        <TextField
          palette={palette}
          type="email"
          value={email}
          onChange={onEmailChange}
          placeholder="you@company.com"
          ariaLabel="Email"
        />
      )}
    </div>
  );
}
